// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type ProfileIconProps = SvgIconProps

const ProfileIcon: React.FC<ProfileIconProps> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path d="M8 0C3.58887 0 0 3.58887 0 8C0 12.4111 3.58887 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58887 12.4111 0 8 0ZM8 2.33334C10.1136 2.33334 11.8333 4.05306 11.8333 6.16669C11.8333 8.28031 10.1136 10 8 10C5.88641 10 4.16666 8.28028 4.16666 6.16666C4.16666 4.05303 5.88641 2.33334 8 2.33334ZM8 14.6667C5.82166 14.6667 3.89 13.6118 2.67272 11.9912C4.00634 11.3495 5.91088 10.6667 8 10.6667C10.0893 10.6667 11.994 11.3496 13.3273 11.9911C12.11 13.6118 10.1784 14.6667 8 14.6667Z" />
    </SvgIcon>
  );
};

export default ProfileIcon;
